import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Logo from "../Asset/Images/Logo.png";
import LogoName from "../Asset/Images/LogoName.png";
import CloseIcon from "@mui/icons-material/Close";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [active, setActive] = useState(false);

  const navItems = [
    { label: "ABOUT", id: "AboutUs" },
    { label: "PORTFOLIO", id: "Portfolio" },
    { label: "TEAM", id: "Team" },
    { label: "INVESTORS", id: "GOOGLE" },
    { label: "PITCH", id: "" }, // PITCH will be handled specially
  ];

  const handleScroll = (id) => {
    if (id === "GOOGLE") {
      window.open("https://auth.venture360.co/login?account=cistern", "_blank");
      if (open) setOpen(false);
      return;
    }
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
    if (open) setOpen(false); // Close drawer on mobile
  };

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const handlePitchClick = () => {
    window.open(
      "https://cisterncapital.decilehub.com/submit_your_company",
      "_blank"
    );
    if (open) setOpen(false); // Close drawer on mobile
  };

  return (
    <>
      <AppBar
        position="static"
        color="transparent"
        elevation={0}
        sx={{
          background: theme.palette.background.paper,
          py: 1,
          px: { xs: 0, sm: 0, md: 0 },
          maxWidth: "1550px",
          mx: "auto",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between", alignItems: "center" }}>
          {/* Logo */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Box
              component="img"
              src={Logo}
              alt="Logo"
              sx={{ height: { md: 60, xs: 40 } }}
            />
            <Box
              component="img"
              src={LogoName}
              alt="LogoName"
              sx={{ height: { md: 60, xs: 30 } }}
            />
          </Box>

          {/* Desktop Menu */}
          {!isMobile ? (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box
                sx={{
                  transform: active ? "translateX(0)" : "translateX(20px)",
                  opacity: active ? 1 : 0,
                  transition: "transform 0.5s ease, opacity 0.5s ease",
                }}
              >
                <Box display="flex" alignItems="center" gap={5}>
                  {navItems.map(({ label, id }) => {
                    const isPitch = label === "PITCH";
                    return (
                      <Typography
                        variant="body2"
                        key={label}
                        color="primary"
                        onClick={() => (isPitch ? handlePitchClick() : handleScroll(id))}
                        sx={{
                          fontWeight: 500,
                          cursor: "pointer",
                          position: "relative",
                          fontFamily: theme.fonts.secondary,
                          "&:hover": {
                            color: "#C86400",
                          },
                        }}
                      >
                        {label}
                      </Typography>
                    );
                  })}
                </Box>
              </Box>

              <IconButton
                onClick={() => setActive((prev) => !prev)}
                edge="end"
                sx={{
                  ml: 2,
                  color: "primary.main",
                  "&:hover": {
                    color: "#C86400",
                  },
                }}
              >
                {active ? <CloseIcon /> : <MenuIcon />}
              </IconButton>
            </Box>
          ) : (
            <Box sx={{ pr: 2 }}>
              <IconButton onClick={toggleDrawer} edge="end">
                <MenuIcon />
              </IconButton>
            </Box>
          )}
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer anchor="right" open={open} onClose={toggleDrawer}>
        <Box sx={{ width: 250 }} role="presentation">
          <List>
            {navItems.map(({ label, id }) => {
              const isPitch = label === "PITCH";
              return (
                <ListItem
                  button
                  key={label}
                  onClick={() => (isPitch ? handlePitchClick() : handleScroll(id))}
                >
                  <ListItemText primary={label} />
                </ListItem>
              );
            })}
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default Navbar;
